















import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

@Component({
    components: {

    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class CopyController extends Vue 
{
    private getCurrentLayer()
    {
        var document = this.$store.getters.document;
        var page = document.pageList[document.currentPageIndex];
        var surface = page.getSurface(document.isReverseSurface);
        var design = surface.getDesign(page.currentDesignPosition);
        return design != null ? design.currentLayer : null;
    }

    private copy(isReverse : boolean)
    {
        var layer = this.getCurrentLayer();
        if(layer == null) { return; }

        // 面へレイヤー複製
        this.$emit("doCommand", "dupilicateLayerToSurface", { layer : layer, isReverse : isReverse });
    }
}
